import AsyncStorage from '@react-native-async-storage/async-storage'
import dayjs from 'dayjs'

// My position is saved on the server at most once a day per account: every
// save is a server call (a cost), and contacts need no fresher position.
const LAST_SHARED_DAY_KEY = 'location_last_shared_day'

const storageKey = (accountId: string) => `${LAST_SHARED_DAY_KEY}_${accountId}`
const localDay = (date: Date) => dayjs(date).format('YYYY-MM-DD')

/**
 * Takes today's single save for this account (the phone's calendar day):
 * false when it is already taken. It is taken before sending, so a reload or
 * another screen opened meanwhile does not send a second one.
 *
 * `serverLastSharedAt` is the date of the last save the server already has
 * (from my profile): when another device saved today, this one does not.
 */
export async function claimLocationShare(
  accountId: string,
  now: Date = new Date(),
  serverLastSharedAt?: string | null,
): Promise<boolean> {
  const key = storageKey(accountId)
  const today = localDay(now)
  if ((await AsyncStorage.getItem(key).catch(() => null)) === today) return false
  await AsyncStorage.setItem(key, today).catch(() => {})
  if (serverLastSharedAt && localDay(new Date(serverLastSharedAt)) === today) return false
  return true
}

/** Gives today's save back when it could not happen, so it can be tried again. */
export async function releaseLocationShare(accountId: string): Promise<void> {
  await AsyncStorage.removeItem(storageKey(accountId)).catch(() => {})
}
